import { render } from "./BrDashboard.vue?vue&type=template&id=1d000aec&scoped=true"
import script from "./BrDashboard.vue?vue&type=script&lang=js"
export * from "./BrDashboard.vue?vue&type=script&lang=js"

import "./BrDashboard.vue?vue&type=style&index=0&id=1d000aec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d000aec"]])

export default __exports__